import Image from "next/image";
import React from "react";
import { buildListingTitle } from "utils/generateFeeds/generateRssFeed";
import style from "./style.module.css";

function index({
  t,
  lang,
  link,
  listing,
  image,
  buildUrlImageWithOperations,
}: {
  t: any;
  lang: string;
  link: any;
  listing: any;
  image: any;
  buildUrlImageWithOperations: any;
}) {
  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
          minWidth: "100%",
          scrollSnapAlign: "start",
        }}
      >
        <Image
          unoptimized
          priority={false}
          alt={buildListingTitle(listing, t, lang)}
          // fill
          width={0}
          height={220}
          style={{
            position: "relative",
            objectFit: "cover",
            objectPosition: "center",
            width: "100%",
            minWidth: "100%",
            //   scrollSnapAlign: "start",
            opacity: "0.4",
            filter: "blur(27px)",
          }}
          src={
            typeof image == "string"
              ? buildUrlImageWithOperations(image, false)
              : image
              ? buildUrlImageWithOperations(image, false)
              : "https://storage.googleapis.com/headers-agenz/logo-agenz/agenz-logo-white.png"
          }
        />
        <span className={style.btn}>{t("Voir l'annonce")}</span>
      </div>
    </>
  );
}

export default index;
